module.exports = "<h2 id=jpex-resolve>Jpex.$resolve</h2> <p><code>Function(factoryName, [namedParameters])</code><br>Resolves a specific factory. </p> <p><code>factoryName</code> can either be a string or an array of strings. If <code>factoryName</code> is an array, the return value is an equivalent array of resolved factories.</p> <pre><code class=lang-javascript>var resolved = Jpex.$resolve(&#39;myFactory&#39;, {myConstant : &#39;foo&#39;});\n</code></pre> ";


//////////////////
// WEBPACK FOOTER
// ./src/content/api/resolve.md
// module id = 40
// module chunks = 0